import React from 'react';

function Field({ value, maxLength, render, data }) {
  if (typeof render === 'function') {
    return <>{render(value, data)}</>;
  }

  if (!value) return <>-</>;

  if (maxLength && typeof value === 'string' && value.length > maxLength) {
    return <>{value.substr(0, maxLength)}...</>;
  }

  return <>{value}</>;
}

export default Field;
